<template>
  <div class="noCarParkingcomm">
    <topNav :title="title"></topNav>
    <section class="list list_comms">
      <ul v-show="commList && commList.length">
        <li class="comm_item" v-for="(item, index) in commList" :key="index" @click="getParking(item)">
          <div class="commname">{{ item.commname }}</div>
        </li>
      </ul>
      <div class="empty_container" v-show="!commList.length && !loadingComm">
        <div class="cont">
          <div class="icon icon_noinvoice"></div>
          <p class="tips">暂无社区</p>
        </div>
      </div>

      <div class="loadmore" v-if="loadingComm"><van-loading type="spinner" /></div>
    </section>
  </div>
</template>
<script>
import topNav from "../topnav/topnav"
import { DETAIL as API } from "@/assets/api"

export default {
  name: 'noCarParkingcomm',
  components: {
    topNav,
  },
  data() {
    return {
      title: "选择社区",
      loadingComm: false,
      commList: [],

    }
  },
  computed: {

  },
  methods: {
    getComms() {
      this.loadingComm = true
      this.$http({
        method: 'post',
        url: API.GET_COMM_LIST,
        success: function (res) {
          if (res.code == 500) {
            this.Toast(res.msg)
            this.loadingComm = false
            return
          }
          if (res.data && res.data.length > 0) {
            this.commList = res.data
          }
          this.loadingComm = false
        }.bind(this),
        error: function (error) {
          this.loadingComm = false
        }
      })
    },
    getParking(item) {
      var query = {
        commname: item.commname,
      }
      this.$router.push({ name: 'noCarParking', query: query })
    },
  },
  created() {
    this.getComms()
  },
}
</script>
<style lang="less" scoped>
.noCarParkingcomm {
  min-height: 100vh;
  border-bottom: 1px solid #fff;
  background-color: #fff;
  box-sizing: border-box;
}

.commname {
  font-size: 17px;
  line-height: 32px;
  text-align: center;
}


.list_comms {
  .comm_item {
    position: relative;
    height: 210px/2;
    width: 705px/2;
    margin: 10px auto;
    background: url('../../../static/images/bg_parkingname.png') center no-repeat;
    background-size: 100%;

    .commname {
      width: 100%;
      font-size: 20px;
      letter-spacing: 2px;
      color: #ffffff;
      font-family: AlibabaPuHuiTi-Regular;
      line-height: 90px;
    }
  }

  .emptyTip {
    font-size: 16px;
    text-align: center;
    line-height: 60px;
  }
}

.empty_container {
  margin-top: 80px;

  .cont {
    margin-bottom: 30px;

    .icon_noinvoice {
      width: 161px;
      height: 127px;
      margin: 0 auto;
      background: url('../../../static/images/icon_noinvoice.png') center no-repeat;
      background-size: 100% auto;
    }

    .tips {
      text-align: center;
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my/noCarParkingcomm.vue